module.exports = __webpack_public_path__ + "img/phone-transparent-1-layer.98d176d6.png";